export default __webpack_public_path__ + "static/media/Group 1284.cdf816cc.png";